<template>
  <div>
    <v-dialog v-model="dialogLocal" width="500px">
      <v-card>
        <v-card-title>{{ lang.assign_coupon }}</v-card-title>
        <v-divider class="ma-0"></v-divider>
        <v-container grid-list-sm class="pa-4 mt-6">
          <v-select
            v-if="existing"
            outlined
            dense
            v-model="coupon"
            :items="coupons"
            :item-text="text"
            item-value="id"
            label="Existing Licences"
            return-object
          ></v-select>

          <!-- <v-btn
            block
            text
            color="primary"
            v-if="!existing"
            @click="useExisting()"
          >
            <v-icon left small>fa-light fa-dollar-sign</v-icon
            >{{ lang.use_existing_licences }}</v-btn
          > -->

          <v-btn block text color="pink" @click="add_new = true">
            <v-icon left>add</v-icon>{{ lang.assign_to_licence }}</v-btn
          >
        </v-container>
        <v-divider class="ma-0"></v-divider>

        <v-card-actions>
          <v-spacer />
          <v-btn text color="secondary" @click="dialogLocal = false">{{
            lang.cancel
          }}</v-btn>
          <!-- <v-btn text color="primary" @click="addCoupon">{{
            lang.add_coupon
          }}</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <addCoupon
      @adding="dialogLocal = false"
      @added="addNewCoupon"
      :plans="plans"
      :dialog="add_new"
      @close="add_new = false"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import addBtn from "@/components/addBtn";
import addCoupon from "@/pages/coupons/add_coupon.vue";
const coupons = require("@/pages/coupons/coupons.js").coupons;
const logs = require("@/classes/logs/logs.js").Logs;
var me;
export default {
  data() {
    return {
      isInit: false,
      existing: false,
      add_new: false,
      coupons: [],
      coupon: {},
      plans: [],
      pageLoading: false,
    };
  },
  components: {
    addBtn,
    addCoupon,
  },
  props: {
    user: Object,
    dialog: Boolean,
  },
  watch: {
    dialog: function(val) {
      if (!val) return;
    },
  },
  computed: {
    ...mapState(["lang", "adminUser"]),
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },
  mounted() {
    coupons.init(this);
  },
  methods: {
    useExisting() {
      if (!this.isInit) {
        this.getCoupons();
      }
      this.existing = true;
    },
    text(item) {
      return (
        item.name +
        " - " +
        item.metadata.qty +
        " " +
        this.lang.licenses +
        " - " +
        item.amount_off / 100 +
        " " +
        item.currency
      );
    },
    updateParent() {
      this.$emit("update");
    },
    addNewCoupon(coupon) {
      this.coupon = coupon;
      this.addCoupon();
    },
    addCoupon() {
      //console.log(this.coupon, me.user.account);
      const me = this;
      this.adminUser.sendToServer(
        "put",
        "/users/" + me.user.account + "/coupon/" + this.coupon.id,
        function(res) {
          logs.print("manage.getCoupons", res);
          if (res.status) {
            me.adminUser.clearServerCache(me.updateParent);

            me.$toastr("success", me.lang.added_coupon_success_user);
          } else {
            me.$toastr("error", res.error_msg);
            console.error("coupons.getPlans", res.error_msg);
          }

          me.pageLoading = false;
        },
        function() {
          me.dialogLocal = false;
        }
      );
    },
    getCoupons() {
      logs.print("getAll");
      var me = this;
      me.pageLoading = true;
      me.coupons = [];
      this.adminUser.sendToServer(
        "get",
        "/coupons",
        function(res) {
          logs.print("manage.getCoupons", res);
          if (res.status) {
            res.data.forEach((item) => {
              if (item.valid) {
                if (!me.coupon.id) me.coupon = item;
                me.coupons.push(item);
              }
            });
          } else {
            console.error("coupons.getPlans", res.error_msg);
          }

          me.pageLoading = false;
        },
        function() {}
      );
    },
  },
};
</script>
